export default {
    issue_date: 'Issue date',
    name: 'Name',
    download: 'Download',
    download_button: 'Download',
    price: 'Price',
    paid: 'Paid',
    rest_to_pay: 'Due to pay:',
    paid_in_advance: 'Prepaid:',
    all_paid: 'Everything is paid',
}
